<template>
	<div class="banner">
	</div>
</template>

<script>
	export default {
		name: 'HeaderBanner',
		mounted() {}
	}
</script>

<style lang="scss" scoped>
	@import '@/assets/css/common/HeaderBanner.scss';
</style>